<template>
  <nav :class="{'layer-selector': true, 'layer-selector--mobile-opened': menuMobileIsOpen}">
    <div class="layer-selector__header">
      <translated-text-component translation="nav_header_1" />
    </div>
    <div class="layer-selector__layers">
      <LayerCheckbox
         v-if="checkVal('EVENTS_ENABLE')"
        :checked="checkSomeEventActive()"
        :small="isSmall"
        icon="events_switcher"
        label="nav_events"
        @click="handleEventsChange($event.target.checked)"
        :tabIndex="1"
      >
        <SubLayerCheckbox
          v-for="category in eventCategories"
          :key="category.key"
          :checked="eventLayers[category.key]"
          :small="isSmall"
          :icon="category.icon_code"
          :label="checkHasTranslation(`EVENT_CATEGORY_NAME_${category.key}`) ? `EVENT_CATEGORY_NAME_${category.key}` : category.key"
          @click.stop="handleEventCategoryChange(category.key, $event.target.checked)"
          :isDynamic="true"
          :hasTranslation="checkHasTranslation(`EVENT_CATEGORY_NAME_${category.key}`)"
        >
        </SubLayerCheckbox>
      </LayerCheckbox>
      <LayerCheckbox
        v-if="checkVal('EVENTS_ENABLE')"
        :checked="eventList"
        :small="isSmall"
        icon="events_list_switcher"
        label="nav_event_list"
        @click="handleEventList($event.target.checked)"
        :tabIndex="2"
      >
      </LayerCheckbox>
      <LayerCheckbox
        v-if="checkVal('TRAFFIC_ENABLE')"
        :checked="trafficLayer"
        :small="isSmall"
        icon="traffic_switcher"
        label="nav_traffic"
        @click="handleTrafficChange($event.target.checked)"
        :tabIndex="3"
      >
        <LayerCustom
          :checked="true"
          :small="isSmall"
          :parentState="trafficLayer"
        >
          <TrafficSmallLegend />
        </LayerCustom>
      </LayerCheckbox>
      <LayerCheckbox
        :checked="checkSomeParkingLayerActive()"
        :small="isSmall"
        icon="parking_switcher"
        label="nav_parkings"
        @click.stop="handleAllParkingsLayersChange($event.target.checked)"
        :tabIndex="4"
      >
        <SubLayerCheckbox
          v-if="checkVal('PARKINGS_ENABLE')"
          :checked="parkingsLayer"
          :small="isSmall"
          :parentState="parkingsLayer"
          icon="marker_parking"
          label="nav_parkings"
          @click.stop="handleParkingsChange($event.target.checked)"
        >
        </SubLayerCheckbox>
        <SubLayerCheckbox
          v-if="checkVal('PARKING_SPOTS_ENABLE')"
          :checked="parkingSpotsLayer"
          :small="isSmall"
          :parentState="parkingsLayer"
          icon="marker_parking_normal_spot"
          label="subnav_parking_spaces"
          @click.stop="handleParkingSpotsChange($event.target.checked)"
        >
        </SubLayerCheckbox>
        <SubLayerCheckbox
          v-if="checkVal('PARKING_ZONE_ENABLE')"
          :checked="parkingZonesLayer"
          :small="isSmall"
          :parentState="parkingsLayer"
          icon="marker_parking_zone"
          label="subnav_parking_zones"
          @click.stop="handleParkingZonesChange($event.target.checked)"
        >
        </SubLayerCheckbox>
        <SubLayerCheckbox
          v-if="checkVal('PARKING_METER_ENABLE')"
          :checked="parkingMetersLayer"
          :small="isSmall"
          :parentState="parkingsLayer"
          icon="marker_parkometer"
          label="subnav_parking_meters"
          @click.stop="handleParkingMetersChange($event.target.checked)"
        >
        </SubLayerCheckbox>
        <SubLayerCheckbox
          v-if="checkVal('PARKING_BOARD_ENABLE')"
          :checked="parkingBoardsLayer"
          :small="isSmall"
          :parentState="parkingsLayer"
          icon="marker_parking_tip"
          label="subnav_parking_boards"
          @click.stop="handleParkingBoardsChange($event.target.checked)"
        >
        </SubLayerCheckbox>
        <LayerCustom
          v-if="checkVal('PARKING_GROUPS_ENABLE')"
          :checked="parkingsLayer"
          :small="isSmall"
          :parentState="parkingsLayer"
        >
          <ParkingGroupLegend />
        </LayerCustom>
      </LayerCheckbox>
      <LayerCheckbox
        v-if="checkVal('CAMS_ENABLE')"
        :checked="cameras"
        :small="isSmall"
        icon="camera_switcher"
        label="nav_cameras"
        @click="handleCamerasChange($event.target.checked)"
        :tabIndex="5"
      >
      </LayerCheckbox>
      <LayerCheckbox
        v-if="checkVal('VMS_ENABLE')"
        :checked="vmsBoardsLayer"
        :small="isSmall"
        icon="vms_board_switcher"
        label="nav_vms"
        :tabIndex="8"
        @click="handleVmsBoardsChange($event.target.checked)"
      >
      </LayerCheckbox>
      <LayerCheckbox
        v-if="checkVal('RADARS_ENABLE')"
        :checked="radarBoardsLayer"
        :small="isSmall"
        icon="radar_board_switcher"
        label="nav_radars"
        :tabIndex="11"
        @click="handleRadarBoardsChange($event.target.checked)"
      >
      </LayerCheckbox>
      <LayerCheckbox
        v-if="checkVal('POI_ENABLE')"
        :checked="checkSomePoiActive()"
        :small="isSmall"
        icon="poi_switcher"
        label="nav_poi"
        @click="handlePoiChange($event.target.checked)"
        :tabIndex="6"
      >
        <SubLayerCheckbox
          v-for="category in poiCategories"
          :key="category.id"
          :checked="poiLayer[category.id]"
          :small="isSmall"
          :icon="category.icon_code"
          :label="checkHasTranslation(category.id) ? category.id : category.name"
          @click.stop="handlePoiCategoryChange(category.id, $event.target.checked)"
          :isDynamic="true"
          :hasTranslation="checkHasTranslation(category.id)"
        >
        </SubLayerCheckbox>
      </LayerCheckbox>
      <!-- <LayerCheckbox
        v-if="checkVal('OW_ENABLE')"
        :checked="false"
        :small="isSmall"
        icon="weather_station_switcher"
        label="nav_meteo"
        @click="handleOpenWeather($event.target.checked)"
        :tabIndex="7"
      >
      </LayerCheckbox> -->
      <LayerCheckbox
        v-if="checkVal('TRAVEL_ENABLE')"
        :checked="trackLayer"
        :small="isSmall"
        icon="way_switcher"
        label="nav_track"
        :tabIndex="9"
        @click="handleTrackChange($event.target.checked)"
      >
      </LayerCheckbox>
      <LayerCheckbox
        v-if="checkVal('WEATHER_STATIONS_ENABLE')"
        :checked="weatherStationsLayer"
        :small="isSmall"
        icon="weather_station_switcher"
        label="nav_meteo"
        @click="handleWeatherStationsChange($event.target.checked)"
        :tabIndex="7"
      >
      </LayerCheckbox>
      <LayerCheckbox
        v-if="checkVal('BIKE_STATIONS_ENABLE')"
        :checked="bikeStationsLayer"
        :small="isSmall"
        icon="marker_bike"
        label="nav_bike"
        @click="handleBikeStationsChange($event.target.checked)"
        :tabIndex="10"
      >
      </LayerCheckbox>

<!--
      <li
        v-for="point in poiPoints"
        :key="point.properties.id"
      >
      </li> -->
    </div>
    <!-- <div class="layer-selector__breaker"></div>
    <div class="layer-selector__menu">
      <ArticleList />
    </div>
     -->
    <div class="layer-selector__switch-mode"
         :title="menuMobileIsOpen ? 'Kliknij i zwiń menu' : 'Kliknij i rozwiń menu'"
         @click="menuMobileIsOpen =! menuMobileIsOpen"
         :class="{ 'layer-selector__switch-mode--opened': menuMobileIsOpen }"
    >
      <i class="mdi mdi-chevron-right"></i>
    </div>
  </nav>
</template>

<script lang="ts">
/*eslint-disable */
/* tslint:disable */
import { computed, defineComponent, Ref, ref, provide, toRaw } from 'vue';
import LayerCheckbox                           from '@/components/map/overlays/LayerCheckbox.vue';
import SubLayerCheckbox         from '@/components/map/overlays/SubLayerCheckbox.vue';
import LayerCustom         from '@/components/map/overlays/LayerCustom.vue';
import TrafficSmallLegend         from '@/components/structural/TrafficSmallLegend.vue';
import ParkingGroupLegend         from '@/components/structural/ParkingGroupLegend.vue';
import useOptions               from '@/components/composers/useOptions';
import store                    from '@/store';
import { LayerControlEnum } from '@/enums/LayerControlEnum';
import ArticleList from '@/components/structural/ArticleList.vue';

const LayerSelector: object = defineComponent({
  components: {
    LayerCheckbox,
    SubLayerCheckbox,
    LayerCustom,
    TrafficSmallLegend,
    ParkingGroupLegend,
    ArticleList,
  },
  name: 'LayerSelector',
  setup() {
    let windowWidth = window.innerWidth;
    const isSmall = ref(windowWidth > 768 ? false : true);
    const menuMobileIsOpen = ref(false);

    const poiCategories: Ref<any> = computed(() => store.state.poiLayers.layers);
    const eventCategories: Ref<any> = computed(() => 
      store.state.eventCategories.filter((category: any) => category.value === true)
    );

    const showTranslateWidget = ref(false);
    const handleTranslateWidget = () => {
      showTranslateWidget.value = !showTranslateWidget.value;
    };

    const checkSomePoiActive = () => {
      const poiLayersStates = computed(() => store.state.settings.mapPoiLayers);
      const poiStatesArray = Object.values(poiLayersStates.value);

      return poiStatesArray.includes(true);
    };

    const checkSomeEventActive = () => {
      const eventLayersStates = computed(() => store.state.settings.mapEventLayers);
      const eventStatesArray = Object.values(eventLayersStates.value);

      return eventStatesArray.includes(true);
    };

    const checkSomeParkingLayerActive = () => {
      const someActive = computed(() => 
        store.state.settings.map[LayerControlEnum.SHOW_PARKINGS]
        || store.state.settings.map[LayerControlEnum.SHOW_PARKING_ZONES]  
          || store.state.settings.map[LayerControlEnum.SHOW_PARKING_SPOTS]
          || store.state.settings.map[LayerControlEnum.SHOW_PARKING_BOARDS]
          || store.state.settings.map[LayerControlEnum.SHOW_PARKING_METERS]
      );
      
      return someActive.value;
    };

    const checkHasTranslation = (translationKey: string) => {
      const { translations } = store.state;
      const allTranslationsKeys = Object.keys(translations);

      if (allTranslationsKeys.includes(translationKey)) {
        return true;
      }

      return false;
    };

    return {
      isSmall,
      menuMobileIsOpen,
      poiCategories,
      eventCategories,
      checkSomePoiActive,
      checkSomeEventActive,
      checkSomeParkingLayerActive,
      checkHasTranslation,
      showTranslateWidget,
      handleTranslateWidget,
      ...useOptions(),
    };
  },
  methods: {
    checkVal(val: string): boolean {
      const {staticParams} = store.state.settings;

      return staticParams.hasOwnProperty(val) && staticParams[val] === true;
    }
  }
});
export default LayerSelector;
</script>

<style scoped lang="scss">

.layer-selector {
  position: fixed;
  top: 0;
  background-color: $main-bg-color;
  z-index: 1;
  width: rem(255px);
  height: 100%;
  transition: all ease-in-out 0.5s;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  padding-top: rem(9px);
  padding-bottom: rem(6px);
  border: 2px solid $nav-layers-box-border;
  box-shadow: 0 0 10px 0px rgba(#000000, 0.3);

  @include width-until($mobile) {
    transform: translate(-100%);
  } 

  &--mobile-opened {
    @include width-until($mobile) {
      transform: translate(0);
    }
  }

  &__header {
    font-size: rem(28px);
    color: $yellow-static;
    font-weight: 700;

    @include width-until($mobile) {
      font-size: rem(18px);
    }
  }

  &__breaker {
    height: 2px;
    width: 90%;
    background-color: $yellow-static;
    margin: 10px 0;

    @include width-until($mobile) {
      display: none;
    };
  }

  &__menu {
    @include width-until($mobile) {
      display: none;
    };
  }

  &__layers {
    width: 100%;
    overflow-y: auto;

    @include width-until($mobile) {
      height: auto;
      overflow-x: hidden;
      overflow-y: auto;
      // max-height: 60vh;
    }

    @include width-from($mobile) {
      // display: flex;
      // justify-content: center;
      // max-width: 45.5rem;
    }

    &--disabled {
      pointer-events: none;
    }
  }

  &__switch-mode {
    display: flex;
    justify-content: center;
    align-items: center;
    width: rem(30px);
    height: rem(36px);
    position: absolute;
    top: 40px;
    left: 100%;
    background-color: $main-bg-color;
    color: $main-font-color;
    border-radius: 0 8px 8px 0;
    cursor: pointer;

    &--opened {
      i {
        transform: rotate(180deg);
      }
    }

     @include width-from($mobile) {
      display: none;
     }

    i {
      font-size: 36px;
      transition: .5s;
    }
  }

  &--small {
    @include width-until($mobile) {
      width: rem(64px);
    }

    .layer-selector__switch-mode {
      svg {
        width: rem(15px);
        height: rem(26px);
        transform: rotateY(0deg);
      }
    }
  }

  .layer-selector__switch-mode {
    @include width-from($mobile) {
      // display: none;
    }
  }
}
.translator-wrapper {
  position: absolute;
  top: 100%;
  background-color: $main-bg-color;
  color: $font-black;
  padding: 12px;
  max-height: 60vh;
  overflow: auto;
  right: 0;
  z-index: 101;

  @include width-until($mobile) {
    top: 0;
  }
}

.translate__trigger-btn {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  font-size: rem(26px);

  @include width-until($mobile) {
    background-color: $main-bg-color;
    right: -28px;
    top: 61px;
  }

  i {
    color: $font-black;
  }
}



</style>